import { ReferencePyramidDetail, PyramidType, EmployeeLevelEnum } from '../../../types'
import { LimitType } from '../../pyramids/shared/PyramidLimitType.enum'

export const getInitialReferencePyramidData = (
  tableData: ReferencePyramidDetail[] | undefined,
  type: string,
  employeeLevels: EmployeeLevelEnum[],
): ReferencePyramidDetail[] => {
  const tableDataNotExists = !tableData || tableData.length === 0
  if (tableDataNotExists) {
    if (type === PyramidType.Age) {
      return [
        { id: 1, range: '< 30', limitType: LimitType.Min, percentage: 0, displayOrder: 1 },
        { id: 2, range: '30 - 35', limitType: LimitType.Min, percentage: 0, displayOrder: 2 },
        { id: 3, range: '36 - 40', limitType: LimitType.Min, percentage: 0, displayOrder: 3 },
        { id: 5, range: '41 - 45', limitType: LimitType.Min, percentage: 0, displayOrder: 4 },
        { id: 6, range: '> 45', limitType: LimitType.Min, percentage: 0, displayOrder: 5 },
      ] as ReferencePyramidDetail[]
    }

    if (type === PyramidType.Level) {
      return !!employeeLevels
        ? employeeLevels.reverse().map((level, index) => ({
            id: index + 1,
            range: level,
            limitType: LimitType.Min,
            percentage: 0,
            displayOrder: index + 1,
          }))
        : []
    }
    return []
  } else {
    return tableData ? [...tableData].sort((a, b) => a.displayOrder - b.displayOrder) : ([] as ReferencePyramidDetail[])
  }
}
